import { Check } from "lucide-react";

/**
 * Renders the program's pathway tracks (e.g., Brick Challenge → Galileo Technic).
 * Used inline within ProgramLandingPage.
 */
export default function ProgramPathwayTracks({ tracks = [], title = "Program pathway" }) {
  if (!tracks.length) return null;
  return (
    <section data-testid="program-pathway-tracks">
      <p className="eyebrow">{title}</p>
      <h3 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900 mt-2 leading-[1.1]">
        Where your child starts — and where they can grow.
      </h3>
      <div className="mt-6 grid md:grid-cols-2 gap-5">
        {tracks.map((t, i) => {
          const accent = t.accent_color || "#0369A1";
          const secondary = t.secondary_color || "#E0F2FE";
          return (
            <div
              key={t.title}
              className="rounded-[1.75rem] bg-white border p-7 hover:shadow-md transition-all"
              style={{ borderColor: secondary }}
              data-testid={`pathway-track-${t.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            >
              <div className="flex items-center gap-3">
                <span
                  className="flex h-8 w-8 items-center justify-center rounded-full text-sm font-bold"
                  style={{ backgroundColor: secondary, color: accent }}
                >
                  {i + 1}
                </span>
                {t.subtitle && (
                  <span
                    className="pill text-[10px]"
                    style={{ backgroundColor: secondary, color: accent }}
                  >
                    {t.subtitle}
                  </span>
                )}
              </div>
              <h4 className="mt-4 font-display text-xl font-extrabold text-slate-900">
                {t.title}
              </h4>
              <p
                className="mt-1 text-xs uppercase tracking-wider font-bold"
                style={{ color: accent }}
              >
                {t.age_range}
              </p>
              <p className="mt-3 text-sm text-slate-700 leading-relaxed">
                {t.description}
              </p>
              {Array.isArray(t.concepts) && t.concepts.length > 0 && (
                <div className="mt-5">
                  <p className="text-[11px] uppercase tracking-wider font-bold text-slate-500 mb-2">
                    Concepts explored
                  </p>
                  <div className="flex flex-wrap gap-1.5">
                    {t.concepts.map((c) => (
                      <span
                        key={c}
                        className="pill text-[10px]"
                        style={{ backgroundColor: secondary, color: accent }}
                      >
                        {c}
                      </span>
                    ))}
                  </div>
                </div>
              )}
              {Array.isArray(t.projects) && t.projects.length > 0 && (
                <ul className="mt-5 grid grid-cols-2 gap-y-1.5 gap-x-3">
                  {t.projects.map((p) => (
                    <li key={p} className="flex items-start gap-2 text-sm text-slate-700">
                      <Check
                        className="h-3.5 w-3.5 shrink-0 mt-1"
                        style={{ color: accent }}
                      />
                      {p}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
